import { Link } from "react-router-dom";
import { useData } from "../../providers/ContextProvider.jsx";
import { RiMedalLine } from "react-icons/ri";
import { GiClick } from "react-icons/gi";
import { BiDotsVerticalRounded } from "react-icons/bi";
import Coding from "../../images/coding.svg";
import Reading from "../../images/reading.svg";
import "../../styles/general.css";
import "../../styles/queries.css";
import "../../styles/ViewGoals.css";

const images = {
  Reading,
  Coding,
};

function ViewGoalsTable({ goals }) {
  return (
    // <div className="view-goals-container">
    //   <table className="table">
    //     <thead>
    //       <tr className="table-heading">
    //         <th></th>
    //         <th>Habit Name </th>
    //         <th>Unit </th>
    //         <th>Weight </th>
    //         <th>View Progress</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {goals?.map(({ _id, habitName, unit, weight }) => {
    //         return (
    //           <tr className="table-row" key={_id}>
    //             <td>
    //               <span className="icon">
    //                 <RiMedalLine />
    //               </span>
    //             </td>
    //             <td className="uppercase">{habitName}</td>
    //             <td>{unit}</td>
    //             <td>{weight}</td>
    //             <td>
    //               <button className="btn btn-fill-light" title="View Progress">
    //                 <GiClick />
    //               </button>
    //             </td>
    //           </tr>
    //         );
    //       })}
    //     </tbody>
    //   </table>
    // </div>

    <div className="view-goals-grid">
      {goals?.map(({ _id, habitName, unit, weight }) => {
        return (
          <div key={_id} className="goal-card">
            <img src={images[habitName]} alt="habit" className="goal-img" />
            <span className="goal-heading">{habitName}</span>
            <div className="hr"></div>
            <div className="goal-attr">
              <div className="attr">
                <span className="bold attr-name">Unit</span> {unit}
              </div>
              <div className="attr">
                <span className="bold attr-name">Weights</span> {weight}{" "}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
function ViewGoals() {
  const { state, dispatch } = useData();
  const { goals } = state;

  return (
    <main className="main">
      <h3 className="page-heading">Goals Set</h3>
      {console.log({ goals })}
      {goals.length > 0 ? (
        <ViewGoalsTable goals={goals} />
      ) : (
        <div className="not-found-message">
          You haven't set any goals yet! Click{" "}
          <Link to="/set-goals" className="not-found-link">
            here
          </Link>{" "}
          to set goals.
        </div>
      )}
    </main>
  );
}
export default ViewGoals;
